module.exports = __webpack_public_path__ + "img/om.018cd8c4.png";